if ($.scrollTo) {
    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 400,
        offset: -30,
    });
}

if ($.fancybox) {
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.buttons = [
        "zoom",
        //"share",
        // "slideShow",
        //"fullScreen",
        //"download",
        // "thumbs",
        "close"
    ];
    $.fancybox.defaults.hash = false;
}

app.bind('template-fallback', (context) => {
    if (window.deviceType.browser.name == 'IE') {
        $('template[id]').each((templateIndex, template) => {
            $(template).replaceWith(`<script type="text/template" id="${template.id}">${template.innerHTML}</div>`);
        });
    }
}, -1000);


app.bind('youtube-api', (context) => {
    const $scripts = $('script');

    // Не загружаем скрипт больше одного раза
    if (!$scripts.toArray().some((script) => script.src.match('//www.youtube.com/iframe_api'))) {
        $scripts.eq(0).before('<script src="//www.youtube.com/iframe_api">');

        app.youTubeReady = new Promise((resolve, reject) => {
            window.onYouTubeIframeAPIReady = () => {
                resolve();
            }
        });
    }
}, -1000);

app.bind('ymaps-api', (context) => {
    const $scripts = $('script');

    // Не загружаем скрипт больше одного раза
    if (!$scripts.toArray().some((script) => script.src.match('//api-maps.yandex.ru/2.1/'))) {
        $scripts.eq(0).before('<script src="https://api-maps.yandex.ru/2.1/?lang=ru_RU&onload=onYmapsReady">');

        app.ymapsReady = new Promise((resolve, reject) => {
            window.onYmapsReady = () => {
                resolve();
            }
        });
    }
}, -1000);

app.bind('default basic', (context) => {
    $('[js-href]').off('.custom-link').on({
        'click.custom-link': (e) => {
            const target = e.currentTarget.getAttribute('target');
            const href = e.currentTarget.getAttribute('js-href');
            if (!href) return;
            e.preventDefault();

            if (target) {
                window.open(href, target)
            } else {
                document.location.url = href;
            }
        },
    });
});

app.bind('default', function () {
    const $menu = $('[js-toggle-menu]');
    const isMobile = $(window).width() <= 1200;

    $("a[js-scroll]").click(function (e) {
        e.preventDefault();
        const _href = $(this).attr("href");

        if (_href && $(_href).length) {
            if (isMobile) {
                $menu.trigger('close');
            }

            $.scrollTo(`${_href}`, {
                offset: {
                    top: isMobile ? -90 : -30
                }
            });
        }

        return false;
    });
});


app.bind('default', function () {
    const $priceChecker = $('[js-price-checker]');
    $priceChecker.on('click', function () {
        $priceChecker.toggleClass('is-active')
        if ($priceChecker.hasClass('is-active')) {
            $('[js-price-item]').each(function () {
                const $item = $(this)
                const price = $item.data('mounth')
                $item.text(price)
            })
        } else {
            $('[js-price-item]').each(function () {
                const $item = $(this)
                const price = $item.data('year')
                $item.text(price)
            })
        }

    })
});
